import { stepSkyOrchidOrbit } from './131-sky-orchid-orbit.mjs';
import { resolveSkyTwinContact } from './129-sky-twin-executioners.mjs';
import { stepSkyTwinPilot } from './130-sky-twin-tether.mjs';
import { stepSkyMourningOrbit, stepSkyOrbitalThreat } from './127-sky-orbital-flight.mjs';
import { resolveSkyVesperContact } from './125-sky-vesper.mjs';
import { resolveSkyScrapContact } from './124-sky-scrap-emperor.mjs';
import { resolveSkyHourglassContact } from './123-sky-hourglass-king.mjs';
import { resolveSkyIronOrchidContact } from './122-sky-iron-orchid.mjs';
import { resolveSkyMourningBrideContact } from './121-sky-mourning-bride.mjs';
import { resolveSkyPrismContact } from './120-sky-prism-widow.mjs';
import { stepSkyCinderheartSlag } from './119-sky-cinderheart-slag.mjs';
import { stepSkyAuthoredEnemy, skyAuthoredEnemyPilotContact } from './118-sky-authored-enemies.mjs';
import { resolveSkyCinderheartContact } from './117-sky-cinderheart.mjs';
import { bindSkyAuthoredBoss, stepSkyAuthoredBoss } from './116-sky-authored-boss.mjs';
import { stepSkyFlightCourse, skyFlightCourseSpeed } from './113-sky-flight-courses.mjs';
import { skyFlightCapabilities } from './106-sky-capabilities.mjs';
import { markSkyJourneyDeparture, grantSkyWaveReward } from './107-sky-rewards.mjs';
import { prepareSkyJourneyAltitude, stepSkyJourneyAltitude } from './105-sky-leviathan-journey.mjs';
import {
  stepSkyJourney,
  stepSkyJourneyReturn,
  moveSkySquadMember,
  claimSkyJourneyGraze,
} from './104-sky-journey.mjs';
import { startSkyLeviathanFlight, stepSkyLeviathanFlight } from './94-sky-leviathan-flight.mjs';
import { startSkyCathedralFlight, stepSkyCathedralFlight } from './102-sky-cathedral-flight.mjs';
import { stepSkyGuardian, stepSkyTraversal } from './89-sky-guardian-step.mjs';
import { SKY_CLOSE_ENCOUNTER, skyGuardianThreat } from './88-sky-encounter-beat.mjs';
import { skyTerrainHeight, skyAdvanceTerrain } from './87-sky-terrain.mjs';
import { SKY_WORLD, skyGroundTravelSpeed } from './86-sky-world-scale.mjs';
/** Original private rail-shooter policy. World positions are metres, time seconds.
 * A 120Hz caller supplies bounded steering; no renderer, storage or random clock
 * participates in outcomes. Terminal states freeze all scoring and simulation. */
export const SKY_STEP = 1 / 120;
export const SKY_LATERAL_LIMIT = SKY_WORLD.lateralLimit;
import {
  SKY_STAGES,
  SKY_FINAL_GUARDIANS,
  SKY_CONTENT_VERSION,
  skyEncounter,
} from './76-sky-campaign.mjs';
import { skyEquipment, skyUpgradeOffer } from './77-sky-upgrades.mjs';
import { SKY_CHAPTERS, skySquadReward } from './78-sky-combat.mjs';
import { stepSkyOverdrive } from './79-sky-precision.mjs';
import { validateSkyPrototypeRig } from './84-sky-prototype-rig.mjs';
import { emitSkyShots, stepSkyProjectiles, skyProjectileAlive } from './81-sky-projectiles.mjs';
import { skyValidatedAimPoint } from './80-sky-aim.mjs';
import {
  skyEffectiveEquipment,
  skyAbsorbBonusHit,
  stepSkyBonuses,
  stepSkyBonusTarget,
  clearSkyBonuses,
  claimSkyBonus,
} from './82-sky-bonuses.mjs';
export { skyTargetRadius } from './80-sky-aim.mjs';
export const SKY_WORLDS = SKY_STAGES;
const clamp = (n, a, b) => Math.max(a, Math.min(b, n));
/** Create a repeatable staged expedition. Unknown seeds become one.
 * Optional first-guardian numeric rig data is validated/copied at this boundary;
 * malformed data falls back to the authored standard encounter, without I/O.
 * startSector selects a current stage for private testing, never grants rewards
 * or unlocks; invalid/noninteger indices start at zero. startMode="boss" skips
 * approach waves/courses without credit, preserving normal guardian admission
 * and earned defeat rewards; unknown modes use the full journey. */
export function createSkyRun(
  seed = 1,
  { firstGuardianRig, startSector = 0, startMode = 'full' } = {},
) {
  const state = {
    version: SKY_CONTENT_VERSION,
    firstGuardianRig: validateSkyPrototypeRig(firstGuardianRig),
    seed: Number.isFinite(seed) ? seed >>> 0 : 1,
    status: 'ready',
    startMode: startMode === 'boss' ? 'boss' : 'full',
    tick: 0,
    time: 0,
    terrainTravel: 0,
    terrainSpeed: null,
    sector:
      Number.isInteger(startSector) && startSector >= 0 && startSector < SKY_STAGES.length
        ? startSector
        : 0,
    sectorTime: 0,
    encounter: 0,
    encounterTime: 0,
    locomotion: 'fly',
    x: 0,
    y: 4,
    pilotZ: SKY_WORLD.pilotZ,
    traversal: null,
    lives: 3,
    score: 0,
    salvage: 0,
    salvageEarned: 0,
    upgrades: { weapon: 0, nova: 0, booster: 0, shield: 0, dual: 0, drone: 0 },
    drones: [],
    droneShotsFired: 0,
    bonuses: {},
    bonusTargetsDestroyed: 0,
    shotsFired: 0,
    hitsLanded: 0,
    criticalHits: 0,
    armorHits: 0,
    overdriveCharge: 0,
    overdriveTime: 0,
    overdriveDuration: 4,
    overdriveRecovery: 0,
    lastImpact: null,
    damageTaken: 0,
    guardiansDefeated: 0,
    ringsCollected: 0,
    eventId: 0,
    eventKind: 'ready',
    stageResult: null,
    stageStart: { score: 0, shots: 0, hits: 0, salvage: 0, damage: 0, squads: 0 },
    chapterIndex: 0,
    chapterLabel: SKY_CHAPTERS[0].name,
    chapterTotal: 6,
    squads: [],
    squadsCompleted: 0,
    perfectSquadsCompleted: 0,
    precisionKills: 0,
    grazes: 0,
    masteryBonus: 0,
    combo: 0,
    kills: 0,
    grace: 0,
    pulse: 1,
    pulseTime: 0,
    wave: -1,
    shot: 0,
    nextId: 1,
    boss: null,
    rings: [],
    enemies: [],
    shots: [],
    threats: [],
    bursts: [],
    event: 'READY TO FLY',
  };
  prepareSkyJourneyAltitude(state, SKY_STAGES[state.sector]);
  return state;
}
function spawn(s, kind, x, y, z, hp = 1) {
  return { id: s.nextId++, kind, x, y, z, hp, age: 0, baseX: x, fired: false };
}
function burst(s, item, color = 'gold', effect = 'hit', award = {}) {
  s.bursts.push({
    id: s.nextId++,
    x: item.x,
    y: item.y,
    z: item.z,
    life: effect === 'kill' ? 1.05 : 0.6,
    duration: effect === 'kill' ? 1.05 : 0.6,
    color,
    effect,
    quality: item.quality ?? null,
    damage: item.damage ?? 0,
    ...award,
  });
  s.bursts = s.bursts.slice(-24);
}
function hit(s, source) {
  if (s.boss?.aimApproach || s.grace > 0 || skyAbsorbBonusHit(s)) return;
  s.lives--;
  s.damageTaken++;
  s.lastDamage = { id: s.damageTaken, time: s.time, source };
  s.combo = 0;
  s.grace = skyEquipment(s.upgrades).shieldGrace;
  event(s, s.lives ? 'damage' : 'defeat', s.lives ? 'SHIELD HIT · KEEP MOVING' : 'FLIGHT ENDED');
  burst(s, { x: s.x, y: s.y, z: s.flightFrame ? s.pilotZ : 2 }, 'red', 'damage');
  if (!s.lives) {
    s.status = 'over';
    clearSkyBonuses(s);
  }
}
function destroy(s, enemy, source = 'shot') {
  if (enemy.hp <= 0) return;
  if (enemy.kind === 'bonus') {
    enemy.hp = 0;
    const reward = claimSkyBonus(s, enemy);
    s.bonusTargetsDestroyed++;
    if (reward) event(s, 'bonus', `${reward.label} · ${reward.duration}s`);
    s.score += 100;
    earnSalvage(s, 1);
    burst(s, enemy, 'gold', 'kill', { scoreAward: 100, combo: 1, source });
    return;
  }
  if (enemy.kind === 'pillar') {
    enemy.hp = 0;
    s.score += enemy.value ?? 0;
    event(s, 'obstacle-clear', 'PATH CLEARED');
    burst(s, enemy, 'gold', 'kill', { scoreAward: enemy.value ?? 0, combo: 1, source });
    return;
  }
  const memberSquad = s.squads.find((value) => value.id === enemy.squad);
  if (memberSquad?.members?.includes(enemy.id)) {
    if (memberSquad.defeatedMembers.includes(enemy.id)) return;
    memberSquad.defeatedMembers.push(enemy.id);
  }
  enemy.hp = 0;
  if (source !== 'drone') s.combo = Math.min(8, s.combo + 1);
  s.kills++;
  earnSalvage(s, 1);
  const scoreAward = (enemy.value ?? 100) * (source === 'drone' ? 1 : s.combo);
  s.score += scoreAward;
  if (source === 'shot' && !enemy.droneAssisted) s.precisionKills++;
  event(
    s,
    'kill',
    source === 'drone' ? 'ESCORT ELIMINATION' : s.combo > 1 ? `${s.combo}× CHAIN` : 'DIRECT HIT',
  );
  burst(s, enemy, 'gold', 'kill', { scoreAward, combo: source === 'drone' ? 1 : s.combo, source });
  const squad = s.squads.find((value) => value.id === enemy.squad);
  if (squad) {
    squad.kills++;
    if (source === 'shot' && !enemy.droneAssisted) squad.precision++;
    const reward = skySquadReward(squad);
    if (reward) {
      squad.rewarded = true;
      s.squadsCompleted++;
      if (reward.perfect) s.perfectSquadsCompleted++;
      s.score += reward.score;
      const masteryReward = grantSkyWaveReward(s, squad);
      s.lastSquadClear = {
        id: squad.id,
        time: s.time,
        x: enemy.x,
        y: enemy.y,
        z: enemy.z,
        ...reward,
        ...masteryReward,
      };
      event(
        s,
        'squad-clear',
        `${masteryReward?.firstPass ? 'FIRST PASS' : 'RETURN CLEAR'} · +${reward.score}${masteryReward?.powerUp ? ` · ${s.waveReward.label}` : ''}`,
      );
      if (masteryReward?.superchargeReady)
        event(s, 'boss-supercharge-ready', 'BOSS SUPERCHARGE READY');
    }
  }
}
/** Advance exactly one fixed tick in place. Input x/y are normalized velocity;
 * optional targetX/targetY are drag positions. NaN input is ignored. Pulse is a
 * once-per-sector defensive action; holding it cannot manufacture ammunition. */
export function stepSkyRun(s, input = {}) {
  if (s.version !== SKY_CONTENT_VERSION) {
    // Private in-memory runs cannot reinterpret old sector indices after a
    // content replacement. Restart ready; loading must gate the new artwork.
    const replacement = createSkyRun(s.seed, { firstGuardianRig: s.firstGuardianRig });
    for (const key of Object.keys(s)) delete s[key];
    return Object.assign(s, replacement);
  }
  if (s.status !== 'playing') return s;
  const dt = SKY_STEP;
  s.tick++;
  s.time = s.tick * dt;
  if (s.traversal) {
    stepSkyTraversal(s, input, dt, event);
    return s;
  }
  s.sectorTime += dt;
  if (s.boss) s.encounterTime += dt;
  const stage = SKY_STAGES[s.sector];
  if (s.cathedral?.encounterId === 'cathedral-of-thunder' && s.cathedral.sector === s.sector)
    return stepSkyCathedralFlight(s, input, dt, { hit, event, burst, earnSalvage, clearStage });
  if (s.leviathan?.sector === s.sector)
    return stepSkyLeviathanFlight(s, input, dt, { hit, event, burst, earnSalvage, clearStage });
  if (s.boss?.defeated) {
    s.bursts = s.bursts.filter((b) => (b.life -= dt) > 0);
    s.pulseTime = Math.max(0, s.pulseTime - dt);
    s.boss.deathAge += dt;
    if (s.boss.authoredRig) stepSkyAuthoredBoss(s, dt, { event, fireAimed, hit });
    if (s.boss.deathAge >= s.boss.deathDuration) finishGuardian(s, stage);
    return s;
  }
  const previousPilot = { x: s.x, y: s.y, z: s.pilotZ ?? SKY_WORLD.pilotZ };
  const laneY = stepSkyJourneyAltitude(s, stage, dt);
  const priorGround = skyTerrainHeight(s.x, SKY_WORLD.pilotZ, s.terrainTravel ?? 0);
  const terrain =
    s.boss?.arenaMotion === 'fixed'
      ? { travel: s.terrainTravel ?? 0, speed: 0 }
      : skyAdvanceTerrain(
          s.terrainTravel ?? 0,
          s.terrainSpeed,
          skyGroundTravelSpeed(s.locomotion, skyFlightCourseSpeed(s, stage)),
          dt,
        );
  const terrainDelta = terrain.travel - (s.terrainTravel ?? 0);
  s.terrainTravel = terrain.travel;
  s.terrainSpeed = terrain.speed;
  const equipment = skyEffectiveEquipment(s);
  stepSkyOverdrive(s, dt);
  s.grace = Math.max(0, s.grace - dt);
  s.pulseTime = Math.max(0, s.pulseTime - dt);
  const axis = (v) => (Number.isFinite(v) ? clamp(v, -1, 1) : 0);
  const steering = skyFlightCapabilities(s).manual.x ? input : {};
  if (
    !stepSkyMourningOrbit(s, steering, dt, { speed: equipment.lateralSpeed, hit }) &&
    !stepSkyOrchidOrbit(s, steering, dt, { speed: equipment.lateralSpeed, hit }) &&
    !stepSkyTwinPilot(s, steering, dt, { speed: equipment.lateralSpeed, hit })
  ) {
    const horizontal = Number.isFinite(steering.targetX)
      ? clamp(
          (clamp(steering.targetX, -SKY_LATERAL_LIMIT, SKY_LATERAL_LIMIT) - s.x) * 0.12,
          -equipment.lateralSpeed * dt,
          equipment.lateralSpeed * dt,
        )
      : axis(steering.x) * dt * equipment.lateralSpeed;
    s.x = clamp(s.x + horizontal, -SKY_LATERAL_LIMIT, SKY_LATERAL_LIMIT);
    const ground = skyTerrainHeight(s.x, SKY_WORLD.pilotZ, s.terrainTravel);
    const floor = (s.journeyAltitude ? laneY : ground) + SKY_WORLD.pilotAimHeight;
    const ceiling = Math.max(
      laneY + SKY_WORLD.maximumAimHeight,
      s.boss?.authoredRig ? s.boss.authoredFlightCeiling : 0,
      s.twinLesson?.sector === s.sector ? s.twinLesson.flightCeiling : 0,
    );
    // A planted pilot follows the moving world surface while airborne steering
    // retains absolute aim height. No hidden presentation offset changes contacts.
    if (
      s.locomotion === 'run' &&
      Math.abs(s.y - priorGround - SKY_WORLD.pilotAimHeight) < 0.15 &&
      !axis(steering.y) &&
      !Number.isFinite(steering.targetY)
    )
      s.y = floor;
    s.y = clamp(s.y + axis(steering.y) * dt * 9, floor, ceiling);
    if (Number.isFinite(steering.targetY))
      s.y += (clamp(steering.targetY, floor, ceiling) - s.y) * 0.12;
    s.locomotion = s.journeyAltitude || s.y > floor + 0.15 ? 'fly' : 'run';
  }
  stepSkyFlightCourse(s, stage, dt, terrainDelta, previousPilot, {
    event,
    burst,
    earnSalvage,
    hit,
  });
  if (stage.kind === 'bonus') {
    s.bursts = s.bursts.filter((b) => (b.life -= dt) > 0);
    if (s.flightCourse?.complete) clearStage(s);
    return s;
  }
  for (const enemy of s.enemies) markSkyJourneyDeparture(s, enemy);
  if (input.pulse && s.pulse && skyFlightCapabilities(s).weapons) {
    s.pulse = 0;
    s.pulseTime = 0.65;
    s.grace = Math.max(s.grace, 1);
    s.threats = [];
    for (const enemy of s.enemies) {
      if (enemy.kind === 'pillar' && !Number.isFinite(enemy.hp)) continue;
      if (['bonus', 'pillar'].includes(enemy.kind) && enemy.hp > equipment.novaDamage)
        enemy.hp -= equipment.novaDamage;
      else destroy(s, enemy, 'nova');
    }
    if (
      s.boss &&
      !s.boss.cinderheart &&
      !s.boss.prism &&
      !s.boss.mourning &&
      !s.boss.orchid &&
      !s.boss.hourglass &&
      !s.boss.vesper &&
      !s.boss.scrap &&
      !s.boss.twins
    )
      s.boss.hp = Math.max(0, s.boss.hp - equipment.novaDamage);
    event(s, 'nova', 'NOVA RELEASED');
  }
  s.bursts = s.bursts.filter((b) => (b.life -= dt) > 0);
  const journeyReady = stepSkyJourney(s, stage, dt, { spawn, event });
  if (!s.boss && journeyReady && (!s.journeyAltitude || s.journeyAltitude.settled)) {
    if (stage.encounterId === 'gilded-leviathan') {
      startSkyLeviathanFlight(s);
      return s;
    }
    if (stage.encounterId === 'cathedral-of-thunder') {
      startSkyCathedralFlight(s, { requireArtwork: true });
      return s;
    }
    const encounter = skyEncounter(s.sector, s.encounter);
    s.boss = spawn(s, 'boss', 0, 5, -65, 96 + Math.min(48, s.sector * 3));
    s.boss.form = encounter.bossForm;
    s.boss.profile = encounter.bossProfile;
    s.boss.design = encounter.bossDesign;
    s.boss.name = encounter.bossName;
    if (encounter.artVariant === 'first-dragon' && s.firstGuardianRig) {
      s.boss.artVariant = 'first-dragon';
      s.boss.prototypeRig = s.firstGuardianRig;
    }
    s.encounterTime = 0;
    s.boss.maxHp = s.boss.hp;
    s.boss.combatPhase = 1;
    s.boss.phaseAge = 0;
    s.boss.damageStage = 0;
    bindSkyAuthoredBoss(s, stage);
    s.chapterLabel = 'GUARDIAN';
    s.enemies = [];
    s.threats = [];
    event(s, 'guardian-approach', 'GUARDIAN APPROACHING · WATCH THE CREST');
  }
  const speed = skyFlightCourseSpeed(s, stage);
  for (const enemy of s.enemies) {
    // Nova resolves before movement: destroyed attackers cannot fire this tick.
    if (enemy.hp <= 0) continue;
    if (stepSkyJourneyReturn(s, enemy, dt, event)) {
      stepSkyAuthoredEnemy(s, stage, enemy);
      continue;
    }
    enemy.age += dt;
    // Harmless megafauna retain their deliberate cannon opportunity even on a
    // faster route; ground obstacles move with actual terrain and fighters sprint.
    enemy.z +=
      enemy.kind === 'pillar'
        ? terrainDelta
        : (enemy.kind === 'bonus' ? stage.speed : speed) * (enemy.speedScale ?? 1) * dt;
    if (enemy.kind === 'bonus') stepSkyBonusTarget(enemy, dt);
    if (enemy.kind === 'bonus' || (enemy.kind === 'pillar' && enemy.obstacleForm)) {
      enemy.terrainTravel = s.terrainTravel;
      const ground = skyTerrainHeight(enemy.x, enemy.z, s.terrainTravel);
      enemy.y += ground - (enemy.groundY ?? 0);
      enemy.groundY = ground;
    }
    if (enemy.formation) moveSkySquadMember(enemy, dt, speed);
    markSkyJourneyDeparture(s, enemy);
    stepSkyAuthoredEnemy(s, stage, enemy);
    const shots = enemy.firedShots ?? (enemy.fired ? 1 : 0);
    if (
      enemy.kind !== 'pillar' &&
      shots < (enemy.aggression ?? 1) &&
      enemy.z > (enemy.formation ? -60 : -45) + shots * 12 &&
      (!enemy.formation || enemy.charge >= 1)
    ) {
      enemy.fired = true;
      enemy.firedShots = shots + 1;
      enemy.chargeAge = 0;
      stepSkyAuthoredEnemy(s, stage, enemy);
      fireAimed(
        s,
        enemy.authoredAttackSocket ? { ...enemy, ...enemy.authoredAttackSocket } : enemy,
        enemy.attackPattern ?? 'aimed',
      );
    }
    if (
      enemy.hp > 0 &&
      enemy.kind !== 'bonus' &&
      (enemy.authoredEnemyRig
        ? skyAuthoredEnemyPilotContact(enemy, s)
        : Math.abs(enemy.z - 1) < 1 &&
          Math.hypot(enemy.x - s.x, enemy.y - s.y) <
            (enemy.kind === 'pillar' ? (enemy.radius ?? 1.8) : (enemy.radius ?? 1) * 0.85))
    ) {
      hit(s, 'collision');
      if (s.status !== 'playing') return s;
    }
    if (enemy.z > 4 && !['pillar', 'bonus'].includes(enemy.kind) && enemy.hp > 0) s.combo = 0;
  }
  if (s.boss) {
    s.boss.terrainTravel = s.terrainTravel;
    if (!stepSkyAuthoredBoss(s, dt, { event, fireAimed, hit }))
      stepSkyGuardian(s, dt, input, { hit, event, spawn, fireAimed });
  }
  stepSkyCinderheartSlag(s, dt, previousPilot, { hit, burst });
  if (s.status !== 'playing' || s.traversal) return s;
  const capabilities = skyFlightCapabilities(s);
  s.aimPoint = capabilities.aim ? skyValidatedAimPoint(s, input.aimPoint) : null;
  stepSkyBonuses(s, dt);
  if (
    capabilities.weapons &&
    input.fire !== false &&
    (!Object.hasOwn(input, 'aimPoint') || s.aimPoint)
  )
    emitSkyShots(s, skyEffectiveEquipment(s), dt, input.weaponMuzzles);
  stepSkyProjectiles(s, dt, {
    destroy,
    burst,
    resolveContact: (run, target, shot, contact, effect) =>
      resolveSkyCinderheartContact(run, target, shot, contact, effect, { event }) ??
      resolveSkyPrismContact(run, target, shot, contact, effect, { event }) ??
      resolveSkyMourningBrideContact(run, target, shot, contact, effect, { event }) ??
      resolveSkyIronOrchidContact(run, target, shot, contact, effect) ??
      resolveSkyHourglassContact(run, target, shot, contact, effect, { event }) ??
      resolveSkyVesperContact(run, target, shot, contact, effect) ??
      resolveSkyScrapContact(run, target, shot, contact, effect, { event }) ??
      resolveSkyTwinContact(run, target, shot, contact, effect),
  });
  for (const bolt of s.threats) {
    if (s.orbitalFlight) {
      stepSkyOrbitalThreat(s, bolt, dt, previousPilot, { hit });
      if (s.status !== 'playing') return s;
      continue;
    }
    const previousZ = bolt.z;
    bolt.z += dt * (bolt.vz ?? 24);
    bolt.age = (bolt.age ?? 0) + dt;
    bolt.x += bolt.vx * dt;
    bolt.y += bolt.vy * dt;
    if (
      Math.abs(bolt.z - 1) < 0.6 &&
      Math.hypot(bolt.x - s.x, bolt.y - s.y) < SKY_WORLD.pilotContactRadius + (bolt.radius ?? 0)
    ) {
      hit(s, 'projectile');
      bolt.z = 10;
      if (s.status !== 'playing') return s;
    } else if (
      previousZ < 1 &&
      bolt.z >= 1 &&
      Math.hypot(bolt.x - s.x, bolt.y - s.y) < SKY_WORLD.pilotGrazeRadius &&
      claimSkyJourneyGraze(s, bolt)
    ) {
      s.grazes++;
      s.score += 30;
      event(s, 'graze', 'CLOSE DODGE · +30');
    }
  }
  s.enemies = s.enemies.filter((e) => (e.journeyMember || e.z < 6) && e.hp > 0);
  s.shots = s.shots.filter(skyProjectileAlive);
  s.threats = s.threats.filter((e) => (s.orbitalFlight ? !e.spent && e.age < 8 : e.z < 6));
  if (s.status !== 'playing') return s;
  if (s.boss?.hp <= 0) {
    s.boss.defeated = true;
    if (s.boss.vesper) {
      s.boss.vesper.rings = [];
      s.boss.vesper.pulses = [];
    }
    if (s.boss.mourning) {
      s.boss.mourning.beams = [];
      s.boss.mourning.echoes = [];
      s.boss.authoredProps = s.boss.authoredProps.filter((p) => !p.mourningEcho);
    }
    if (s.boss.cinderheart) {
      s.boss.cinderheart.streams = [];
      s.boss.authoredProps = s.boss.authoredProps.filter((prop) => !prop.cinderheartSlag);
    }
    if (s.boss.orchid) {
      s.boss.orchid.clouds = [];
      s.boss.orchid.pollen = false;
      s.boss.authoredProps = s.boss.authoredProps.filter((prop) => !prop.orchidSeed);
    }
    s.boss.breath = null;
    s.boss.deathAge = 0;
    s.boss.deathDuration = s.boss.authoredRig
      ? s.boss.deathDuration
      : s.boss.form === 'leviathan'
        ? 4
        : s.boss.profile === 'stoneOracle'
          ? 3.6
          : 3.2;
    s.boss.damageStage = 3;
    s.boss.vulnerable = false;
    s.score += 5000;
    s.guardiansDefeated++;
    earnSalvage(s, 4);
    s.enemies = [];
    s.threats = [];
    s.shots = [];
    event(s, 'guardian-defeated', 'GUARDIAN BREAKING APART');
  } else if (s.boss && s.encounterTime >= stage.bossSeconds) {
    s.status = 'over';
    clearSkyBonuses(s);
    event(s, 'defeat', 'GUARDIAN ESCAPED');
  }
  return s;
}

function fireAimed(s, origin, pattern, guardian) {
  const offsets = pattern === 'fan' ? [-1.1, 0, 1.1] : pattern === 'paired' ? [-0.5, 0.5] : [0];
  for (const [slot, offset] of offsets.entries()) {
    const bolt = spawn(s, 'threat', origin.x, origin.y, origin.z);
    if (origin.journeyMember) bolt.journeyGrazeKey = `${origin.id}:${origin.firedShots}:${slot}`;
    const flight = Math.max(
      guardian ? SKY_CLOSE_ENCOUNTER.minimumFlightSeconds : 0.7,
      s.orbitalFlight
        ? Math.hypot(s.x - origin.x, s.y - origin.y, s.pilotZ - origin.z) / 24
        : (1 - origin.z) / 24,
    );
    bolt.vx = (s.x + offset - origin.x) / flight;
    bolt.vy = (s.y - origin.y) / flight;
    if (s.orbitalFlight) bolt.vz = (s.pilotZ - origin.z) / flight;
    if (guardian) Object.assign(bolt, skyGuardianThreat(guardian, origin, flight));
    s.threats.push(bolt);
  }
}
function finishGuardian(s, stage) {
  s.boss = null;
  if (stage.kind === 'rush' && s.encounter < SKY_FINAL_GUARDIANS.length - 1) {
    s.encounter++;
    s.encounterTime = 0;
    s.grace = Math.max(s.grace, 1);
    event(s, 'guardian-defeated', 'CONVERGENCE · NEXT GUARDIAN');
  } else clearStage(s);
}

function event(s, kind, text) {
  s.eventId++;
  s.eventKind = kind;
  s.event = text;
}
function earnSalvage(s, amount) {
  s.salvage += amount;
  s.salvageEarned += amount;
}
function clearStage(s) {
  clearSkyBonuses(s);
  const stageHits = s.hitsLanded - s.stageStart.hits;
  const accuracy = stageHits / Math.max(1, s.shotsFired - s.stageStart.shots);
  const mastery =
    (stageHits > 0 && s.damageTaken === (s.stageStart.damage ?? 0) ? 500 : 0) +
    (accuracy >= 0.25 ? 500 : 0);
  s.masteryBonus += mastery;
  s.score += mastery;
  s.stageResult = {
    sector: s.sector,
    name: SKY_STAGES[s.sector].name,
    score: s.score - s.stageStart.score,
    shots: s.shotsFired - s.stageStart.shots,
    hits: s.hitsLanded - s.stageStart.hits,
    salvage: s.salvageEarned - s.stageStart.salvage,
    accuracy: Math.round(accuracy * 100),
    masteryBonus: mastery,
    squads: s.squadsCompleted - (s.stageStart.squads ?? 0),
    course:
      s.flightCourse?.sector === s.sector
        ? {
            collected: s.flightCourse.collected,
            total: s.flightCourse.gates.length,
            bestChain: s.flightCourse.bestChain,
            salvage: s.flightCourse.salvage,
          }
        : null,
  };
  s.sector++;
  // A completed free-flight encounter must release its physical depth before
  // the next rail stage prepares weapons, obstacles and environmental contacts.
  s.pilotZ = SKY_WORLD.pilotZ;
  if (s.orbitalFlight) {
    s.orbitalFlight = null;
    s.flightFrame = null;
    s.flightAimDepth = null;
    s.x = clamp(s.x, -SKY_LATERAL_LIMIT, SKY_LATERAL_LIMIT);
  }
  prepareSkyJourneyAltitude(s, SKY_STAGES[s.sector]);
  s.sectorTime = 0;
  s.encounter = 0;
  s.encounterTime = 0;
  s.wave = -1;
  s.journey = null;
  s.flightCourse = null;
  s.squads = [];
  s.rings = [];
  s.enemies = [];
  s.shots = [];
  s.threats = [];
  s.pulse = 1;
  s.lives = Math.min(skyEquipment(s.upgrades).maxLives, s.lives + 1);
  s.status = s.sector === SKY_STAGES.length ? 'complete' : 'intermission';
  event(
    s,
    s.status === 'complete' ? 'complete' : 'stage-clear',
    s.status === 'complete' ? 'FRONTIER RESTORED' : 'SECTOR CLEAR · SHIELD RESTORED',
  );
}
/** Resume only a held stage intermission. No time, reward or enemy advances while
 * waiting; duplicate/invalid Continue actions are no-ops and preserve the run. */
export function continueSkyRun(s) {
  if (s.status !== 'intermission' || s.sector >= SKY_STAGES.length) return s;
  s.status = 'playing';
  s.stageStart = {
    score: s.score,
    shots: s.shotsFired,
    hits: s.hitsLanded,
    salvage: s.salvageEarned,
    damage: s.damageTaken,
    squads: s.squadsCompleted,
  };
  event(
    s,
    'stage-start',
    SKY_STAGES[s.sector].kind === 'bonus' ? 'SAFE PASSAGE · BREATHE' : 'READY TO FLY',
  );
  return s;
}
/** Spend run-local earned salvage at intermission. Failed offers mutate nothing;
 * successful purchases report exact cost and cannot exceed the policy caps. */
export function buySkyUpgrade(s, key) {
  const offer = skyUpgradeOffer(s, key);
  if (!offer.ok) return offer;
  s.salvage -= offer.cost;
  if (key === 'repair') s.lives++;
  else {
    s.upgrades[key] = offer.level;
    if (key === 'shield') s.lives = Math.min(skyEquipment(s.upgrades).maxLives, s.lives + 1);
  }
  event(s, 'upgrade', key === 'repair' ? 'SHIELD REPAIRED' : `${key.toUpperCase()} UPGRADED`);
  return offer;
}
